import {
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
const prisonerOfWarPage = {
  uiSchema: {
    ...titleUI(content['military-service-pow-title']),
    pow: yesNoUI({
      title: content['military-service-pow-question'],
    }),
  },
  schema: {
    type: 'object',
    required: ['pow'],
    properties: {
      pow: yesNoSchema,
    },
  },
};

export default prisonerOfWarPage;
